<template>
    <template v-if="!payment">
        <button
            v-if="emd.clients.length > 1"
            class="options-icon text-danger px-1 shadow-none transition-opacity duration-150"
            data-testid="remove-client-btn"
            title="Remove Client"
            @click.stop="setDeleteClientRefs(emd, client)"
        >
            <font-awesome-icon :icon="['fas', 'times']" />
        </button>
    </template>
    <template v-else-if="payment?.status === 'Held' || payment?.status === 'Failed'">
        <button
            aria-controls="overlay_menu"
            aria-haspopup="true"
            class="options-icon px-1 text-content-primary shadow-none transition-opacity duration-150"
            :class="payment.id"
            data-testid="menu-btn"
            title="Menu"
            type="button"
            @click="toggleMenu($event, payment, emd.id, client.id)"
        >
            <font-awesome-icon :icon="['fas', 'ellipsis']" />
        </button>
        <Menu
            id="overlay_menu"
            ref="menu"
            :model="menuItems"
            popup
            :pt="{
                root: { class: 'bg-inherit bg-white border-none focus:bg-white p-0 font-inter' },
                menu: {
                    class: 'bg-white min-w-max left-auto font-inter text-xs font-semibold no-underline text-ds-primary-500',
                },
                content: { class: 'hover:bg-white border-none text-inherit hover:text-inherit' },
                menuitem: {
                    class: 'bg-white border-none focus:bg-white px-0 pb-0 pt-0',
                },
                action: 'w-full',
                button: { class: 'focus:bg-white active:bg-white' },
                submenu: 'max-w-max animate-fade-in',
            }"
        >
            <template #item="{ item, props }">
                <a
                    v-bind="props.action"
                    aria-hidden="false"
                    class="flex items-center p-3 hover:bg-ds-primary-50"
                    :href="item.url"
                >
                    <span>{{ item.label }}</span>
                </a>
            </template>
        </Menu>
    </template>
    <a
        v-else
        class="options-icon px-1 text-content-primary"
        data-testid="receipt-btn"
        :href="downloadEarlyDepositClientReceipt(payment.id)"
        title="Download Receipt"
    >
        <font-awesome-icon :icon="['far', 'list-alt']" />
    </a>
</template>

<script setup lang="ts">
import type { EarlyDeposit } from '@/api/interfaces/early-deposit.types';
import {
    downloadEarlyDepositClientReceipt,
    useDeleteClientEarlyDeposit,
    useEarlyDepositMenu,
} from '@/services/early-deposit.service';
import type { PreFilePayment } from '@/types/closinglock.types';
import Menu from 'primevue/menu';

export type EarlyDepositRowActionsProps = {
    emd: EarlyDeposit;
    client: EarlyDeposit['clients'][number];
    payment: Pick<PreFilePayment, 'id' | 'status'> | null;
};

defineProps<EarlyDepositRowActionsProps>();

const { setDeleteClientRefs } = useDeleteClientEarlyDeposit();
const { menu, menuItems, toggleMenu } = useEarlyDepositMenu();
</script>
